<template>
  <div>
    <div class="min-h-screen max-w-screen-2xl relative">
      <div class="flex flex-col space-y-12 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-x-12 brand-card-lg">
        <!-- LEFT SIDE -->
        <div class="flex flex-col justify-between space-y-4 font-semibold leading-8 text-brand-brown">
          <div v-if="!meetingScheduled">
            <p class="text-4xl font-bold mt-4 text-brand-black leading-normal">Start tapping into a whole new revenue stream.</p>
            <p class="mt-4 text-xl leading-8">Effortlessly win back cancelled customers with personalized reactivation campaigns.</p>
            <img class="w-full my-6 shadow-xl rounded-md" src="@/assets/img/mission-control/reactivations-preview.jpg" alt="Churnkey Reactivations" />
            <p class="mt-4 text-base leading-8">
              <span class="text-brand-black font-bold">Schedule time with us</span> to unlock Reactivations, which enables you to:
            </p>
            <ul class="list-disc ml-5 mt-4">
              <li>Utilize cancellation reasons for incredible personalization</li>
              <li>Leverage customer health scores for targeting</li>
              <li>Create unlimited segments &amp; campaigns</li>
              <li>Have complete control over campaign details &amp; offers</li>
            </ul>
            <div class="mt-6">
              <a
                href="https://churnkey.co/blog/preview-three-new-products/?_gl=1*9rgos7*_gcl_au*MzI4MjI0MDc5LjE3MDEyMDcxOTg.#preview-reactivations"
                target="_blank"
                class="el-button border-2 border-brand-light-blue rounded-md"
              >
                <span class="text-base text-brand-blue font-semibold text-left cursor-pointer">Read More →</span>
              </a>
            </div>
          </div>
          <div v-else>
            <p v-if="meetingDisplayName" class="text-4xl font-bold mt-4 text-brand-black leading-normal">Talk soon, {{ meetingDisplayName }}.</p>
            <p v-else-if="meetingScheduled" class="text-4xl font-bold mt-4 text-brand-black leading-normal">Talk soon.</p>
            <p class="mt-8 text-lg font-semibold leading-8 text-brand-brown">
              To get the most out of our strategy and implementation session, it'll help to have some data with you.
            </p>
            <div class="mt-6">
              <a
                class="el-button el-button--primary font-bold text-base text-left cursor-pointer"
                href="https://churnkey.notion.site/churnkey/What-to-get-ready-before-your-call-with-Churnkey-9bc15cfcc00247ee97d1e30983497d80"
                target="_blank"
              >
                <span class="font-bold">What to Get Ready Before Your Call →</span>
              </a>
            </div>
          </div>
        </div>
        <!-- RIGHT SIDE -->
        <div>
          <div class="relative self-center m-auto bg-white rounded-md">
            <div id="booking-page"></div>
          </div>
          <div v-if="meetingScheduled" class="mt-6 hidden">
            <a
              href="https://churnkey.notion.site/churnkey/What-to-get-ready-before-your-call-with-Churnkey-9bc15cfcc00247ee97d1e30983497d80"
              target="_blank"
            >
              <el-button type="plain" class="border-brand-sand border-2 px-10 py-4 rounded-md w-full">
                <span class="text-base text-brand-blue font-semibold">What to Get Ready Before Your Call →</span>
              </el-button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/helpers/event-bus';

export default {
  name: 'EventHome',
  created() {
    if (this.$store.getters.reactivation.enabled) {
      this.$router.push({ name: 'reactivation' });
    }
  },
  data() {
    return {
      data: '',
      meetingScheduled: false,
      meetingDisplayName: '',
    };
  },
  mounted() {
    this.initSavvyCal();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    initSavvyCal() {
      const vm = this;
      // eslint-disable-next-line no-undef
      SavvyCal('inline', { link: 'churnkey-team/reactivations', selector: '#booking-page', theme: 'light' });
      window.addEventListener('savvycal.scheduled', (ev) => {
        // The `detail` property contains the following data about the newly-scheduled event:
        //   id, startAt, endAt, email, displayName, fields, phoneNumber, timeZone, guests
        const data = ev.detail;
        vm.meetingScheduled = true;
        if (data.displayName) {
          vm.meetingDisplayName = data.displayName.split(' ')[0];
        }
        // if (['chargebee', 'braintree', 'stripe', 'paddle'].includes(vm.$store.getters.paymentProvider) && vm.selectedPlan === 'custom') {
        //   vm.step = 'confirm-payment-provider';
        // }
      });
    },
    openChat() {
      eventBus.$emit('openChat');
    },
  },
};
</script>
